import type { Handler } from './handler';
import type { ApiPostRouletteSpinPort } from './ports/api-post-roulette-spin.port';
import type { SpinResult } from '~/types/roulette';
import { resolveAdapter } from '~/adapters/registry';

export const postRouletteSpinHandler: Handler<Params, Ports, Result> = async (
  params,
  ports = {
    apiPostRouletteSpin: resolveAdapter('apiPostRouletteSpin'),
  },
) => {
  return await ports.apiPostRouletteSpin.handle(params.slug);
};

type Params = { slug: string };

type Ports = { apiPostRouletteSpin: ApiPostRouletteSpinPort };

type Result = Promise<SpinResult>;
